import { render, staticRenderFns } from "./inquiryDetailsPopup.vue?vue&type=template&id=37f6bc4a&scoped=true"
import script from "./inquiryDetailsPopup.vue?vue&type=script&lang=js"
export * from "./inquiryDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./inquiryDetailsPopup.vue?vue&type=style&index=0&id=37f6bc4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6bc4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f6bc4a')) {
      api.createRecord('37f6bc4a', component.options)
    } else {
      api.reload('37f6bc4a', component.options)
    }
    module.hot.accept("./inquiryDetailsPopup.vue?vue&type=template&id=37f6bc4a&scoped=true", function () {
      api.rerender('37f6bc4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/inquiryDetailsPopup.vue"
export default component.exports